import React from 'react';
import { Link } from 'react-router-dom';
interface ProjectCardProps {
  title: string;
  category: string;
  description: string;
  image: string;
  tags: string[];
  id: string;
  link?: string;
  comingSoon?: boolean;
}
export function ProjectCard({
  title,
  category,
  description,
  image,
  tags,
  id,
  link = '/work',
  comingSoon = false
}: ProjectCardProps) {
  const content = <div className={`bg-white rounded-xl overflow-hidden shadow-sm transition-all duration-300 h-full border border-slate-100 flex flex-col ${!comingSoon ? 'hover:shadow-xl transform hover:-translate-y-1' : 'opacity-90'}`} data-id="element-172">
      <div className="relative h-48 overflow-hidden bg-slate-100" data-id="element-173">
        <img src={image} alt={title} className={`w-full h-full object-cover transition-transform duration-700 ${!comingSoon ? 'group-hover:scale-105' : ''}`} data-id="element-174" />
        <div className={`absolute inset-0 transition-colors duration-300 ${!comingSoon ? 'bg-blue-900/0 group-hover:bg-blue-900/10' : 'bg-slate-900/20'}`} data-id="element-175" />

        {comingSoon && <div className="absolute top-4 right-4 px-3 py-1.5 bg-white/95 backdrop-blur-sm rounded-full shadow-lg" data-id="element-176">
            <span className="text-xs font-medium text-slate-700 uppercase tracking-wider" data-id="element-177">
              Coming Soon
            </span>
          </div>}
      </div>

      <div className="p-6 flex-1 flex flex-col" data-id="element-178">
        <h3 className={`text-2xl font-light text-slate-900 mb-3 transition-colors ${!comingSoon ? 'group-hover:text-blue-600' : ''}`} data-id="element-179">
          {title}
        </h3>
        <p className="text-slate-600 font-light leading-relaxed mb-4 flex-1" data-id="element-180">
          {description}
        </p>

        <div className="flex flex-wrap gap-2" data-id="element-181">
          {tags.map(tag => <span key={tag} className="px-3 py-1 bg-slate-50 text-slate-500 text-xs rounded-full border border-slate-100" data-id="element-182">
              {tag}
            </span>)}
        </div>
      </div>
    </div>;
  if (comingSoon) {
    return <div className="h-full" data-id="element-183">{content}</div>;
  }
  return <Link to={link} className="group block h-full" data-id="element-184">
      {content}
    </Link>;
}